import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { styled } from "@mui/system";
import { GlobalSideBar, MerchantSideBar } from "../../components";
import { DISPLAY_FLEX, FLEX_DIRECTION_COLUMN } from "../../config/styles";

const LayoutContainer = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  backgroundColor: theme.palette.secondary.contrastText,
  minHeight: "100vh",
  width: "100vw",
}));

const GlobalLayout = () => {
  return (
    <LayoutContainer>
      <GlobalSideBar />
      <Outlet />
    </LayoutContainer>
  );
};

const MerchantLayout = () => {
  const location = useLocation();
  const isFromLandingPage = location.state?.fromScreen === "MainLanding";

  return (
    <LayoutContainer>
      {isFromLandingPage ? <GlobalSideBar /> : <MerchantSideBar />}
      <Outlet />
    </LayoutContainer>
  );
};

const Layout = {
  GlobalLayout: GlobalLayout,
  MerchantLayout: MerchantLayout,
};

export default Layout;
